import { ForgotPasswordModelI, LoginModelI, RefreshTokenModelI } from "./authTypes";
import { Fetch } from "../../utils/fetch";
import { routes } from "./routes";

class AuthService {
  login(payload: LoginModelI) {
    return Fetch("post", routes.login, payload);
  }

  forgotPassword(payload: ForgotPasswordModelI) {
    return Fetch("post", routes.forgotPassword, payload);
  }

  getHelpInfo() {
    return Fetch("get", routes.helpInfo);
  }

  getNewAccessToken(payload: RefreshTokenModelI) {
    return Fetch("post", routes.getNewAccessToken, payload, { deleteAuth: true });
  }

  getUsers() {
    return Fetch("get", routes.getUsers);
  }
}

export default new AuthService();
